import React from 'react';
import { Form } from "react-bootstrap";
import "../../styles/Form.css";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { loginUser } from '../../core/store/actions/auth';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import "../../styles/general.css";
import { Icon } from '@iconify/react/dist/iconify.js';

class LoginForm extends React.Component {
  render() {

    const withIcon = (message) => (
      <span style={{ display:'flex', alignItems:'center', textAlign:'center'}}>
        <Icon icon="f7:exclamationmark-circle-fill" style={{marginRight:'5px', marginLeft:'24px'}}/> {message}
      </span>
    );

    if (!this.props.user) {
      return null;
    }

    return (
      <div>
        <div className="container">
          <div className="title mb-3">Welcome back!</div>
          <div>
            <Formik
              initialValues={{ email: "", password: "" }}
              validationSchema={Yup.object({
                email: Yup.string().email("Invalid email address").required("Required"),
                password: Yup.string().required("Required"),
              })}
              onSubmit={async (values, { setSubmitting }) => {
                try {
                  setSubmitting(true);
                  const profile = await this.props.loginUser(values);
                  if (profile?._id) {
                    this.props.history.push('/main');
                  }
                } catch (error) {
                  console.error('Login failed:', error);
                } finally {
                  setSubmitting(false);
                }
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                <Form onSubmit={handleSubmit} className="outlineSquareBlueLogin">
                  <Form.Group controlId="formEmail" style={{width:'100%'}}>
                    <input
                      className="login-input"
                      placeholder="e-mail"
                      type="text"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    {touched.email && errors.email ? (
                      <div className="error" style={{color:'#CD3E3D'}}>{withIcon(errors.email)}</div>
                    ) : null}
                  </Form.Group>
                  <Form.Group controlId="formPassword" style={{width:'100%'}}>
                    <input
                      className="login-input"
                      placeholder="password"
                      type="password"
                      name="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                    />
                    {touched.password && errors.password ? (
                      <div className="error" style={{color:'#CD3E3D'}}>{withIcon(errors.password)}</div>
                    ) : null}
                    {touched.password && touched.email && !errors.password && this.props.user.error ? (
                      <div variant="danger" className="mt-1 textForm alertMessage" style={{color:'#CD3E3D'}} >{withIcon(this.props.user.error.error)}</div>
                    ) : null}
                  </Form.Group>
                  <div style={{display:'flex', justifyContent:'end', width:'380px'}}>
                    <a href="/forgot-password" className='link' style={{color:'var(--black-oscar)'}}>Forgot Password?</a>
                  </div>
                  <div>
                    <button className="button" disabled={isSubmitting} type="submit" value="Submit" style={{maxWidth:'380px'}}>login</button>
                  </div>
                  <div style={{marginTop:'20px'}}>
                    <a href="/register" className='link' style={{fontSize:'14px', color:'var(--black-oscar)'}}>Don't have an account yet? <b>Create one now</b>!</a>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user });

export default withRouter(connect(mapStateToProps, { loginUser })(LoginForm));
